export default __webpack_public_path__ + "static/iconography-image-i-43bc8c02bc59b204776e9bddbaf16470ff96362b79ca47717e6b273ea37075f0.png";